// Chart colours and fonts from the design tokens (styles/tokens.css), for
// chart.js and recharts alike: both libraries draw on a canvas or SVG and
// cannot use CSS variables directly, so the values are read once from the
// document. The fallbacks are the same values, for tests and old browsers.
const FALLBACK = {
  '--chart-1': '#3F7F14',
  '--chart-2': '#A7ADB3',
  '--chart-3': '#0B110C',
  '--chart-4': '#6DBB2C',
  '--chart-5': '#B45309',
  '--chart-6': '#1E446F',
  '--chart-7': '#9B1C12',
  '--chart-grid': '#E3E8E3',
  '--chart-axis': '#5E6A60',
};

const read = (name) => {
  try {
    const value = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    return value || FALLBACK[name];
  } catch (e) {
    return FALLBACK[name];
  }
};

// '#3F7F14' + 0.15 -> 'rgba(63, 127, 20, 0.15)'
export const withAlpha = (hex, alpha) => {
  const h = hex.replace('#', '');
  const [r, g, b] = [0, 2, 4].map((i) => parseInt(h.slice(i, i + 2), 16));
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const chartColors = () => ({
  series: ['--chart-1', '--chart-2', '--chart-3', '--chart-4', '--chart-5', '--chart-6', '--chart-7'].map(read),
  primary: read('--chart-1'),
  steel: read('--chart-2'),
  dark: read('--chart-3'),
  grid: read('--chart-grid'),
  axis: read('--chart-axis'),
});

export const CHART_FONT = "'Barlow', system-ui, sans-serif";

// chart.js defaults: the app's font, axis and grid colours (call once).
export const applyChartJsTheme = (ChartJS) => {
  const c = chartColors();
  ChartJS.defaults.font.family = CHART_FONT;
  ChartJS.defaults.font.size = 13;
  ChartJS.defaults.color = c.axis;
  ChartJS.defaults.borderColor = c.grid;
  ChartJS.defaults.plugins.legend.labels.boxWidth = 12;
  ChartJS.defaults.plugins.legend.labels.boxHeight = 12;
};
